'use strict';

import angular from 'angular';
import FormController from 'app/controllers/form';

class SpendingController extends FormController {
    /* @ngInject */
    constructor(
        SpendingsService,
        SpendingTypesService,
        EmployeesService,
        $scope,
        $mdDialog,
        $mdToast,
        $state,
        $location,
        $stateParams
    ) {
        let spending = $scope.$parent.$resolve.spending;
        super(
            spending,
            'Gasto',
            SpendingsService,
            null,
            'spendings'
        );
        this.user = $scope.$parent.$resolve.user;
        this.voucherId = $stateParams.voucherId || this.model.voucherId;

        Object.assign(this, {
            SpendingsService,
            SpendingTypesService,
            EmployeesService,
            $mdDialog,
            $mdToast,
            $state,
            $location
        });
        this.btnEnabled = true;

        if (this.user.isAdmin && !this.model.id) {
            this.canChangeEmployee = true;
        } else if (this.user.employee) {
            this.employee = this.user.employee;
            this.model.employee = this.user.employee;
        }

        if (this.model.id) {
            this.neverEditable = true;
            this.employee = this.model.employee;
            this.spendingType = this.model.spendingType;
        } else {
            Object.assign(this.model, {
                voucherId: this.voucherId
            });
        }
    }

    afterFirstSave() {
        this.neverEditable = true;
    }

    $onInit() {
        super.$onInit();
    }

    queryEmployeeSearch() {
        return this.EmployeesService.find({
            filter: {
                where: {
                    name: {
                        regexp: `^${this.searchEmployeeText}/i`
                    }
                }
            }
        });
    }

    selectedEmployeeChange(employee) {
        if (employee) {
            this.model.employee = employee;
            this.employee = employee;
        }
    }
    querySpendingTypeSearch() {
        return this.SpendingTypesService.find({
            filter: {
                where: {
                    name: {
                        regexp: `^${this.searchSpendingTypeText}/i`
                    }
                }
            }
        });
    }

    selectedSpendingType(spendingType) {
        if (spendingType) {
            this.model.spendingType = spendingType;
            this.spendingType = spendingType;
        }
    }

    void(ev) {
        var confirm = this.$mdDialog.prompt()
            .title('Anulación de Gasto')
            .textContent('Ingrese el motivo')
            .placeholder('Motivo de anulación')
            .ariaLabel('Motivo de anulación')
            .required(true)
            .targetEvent(ev)
            .ok('Anular el gasto')
            .cancel('Cancelar');

        this.$mdDialog.show(confirm).then(result => {
            this.showVoidSpin = true;
            this.SpendingsService.void({
                id: this.model.id,
                reason: result
            }).then(() => {
                this.showVoidSpin = false;
                this.model.deletionReason = result;
                this.model.deletedAt = new Date();
            });
        });
    }
}

export default SpendingController;
